<template>
    <div class="faq-overview">
        <div class="row">
            <div class="col-12 col-md-4 col-xl-3 faq-categories">
                <design-2021-admin-afaq-category-nav-component :categories-in="categories"
                                                               @selected-category="changeSelectedCategory($event)">
                </design-2021-admin-afaq-category-nav-component>
            </div>

            <div class="col-12 col-md-8 col-xl-9" v-if="selectedCategory">
                <design-2021-admin-afaq-category-index-component :afaq-tags-in="afaqTagsIn"
                                                                 :category-in="selectedCategory">
                </design-2021-admin-afaq-category-index-component>
            </div>
        </div>
    </div>
</template>

<script>
import {ords} from '../../../../app';

const categoryOrds = ords.use('AfaqCategory')

export default {
    name: "design-2021-admin-afaq-index-content-component",
    props: ['afaqCategoriesIn', 'afaqTagsIn'],
    data() {
        return {
            selectedCategoryId: null,
            categories: [],
            subscription: null,
        }
    },
    methods: {
        changeSelectedCategory(id) {
            this.selectedCategoryId = id;
        }
    },
    computed: {
        selectedCategory() {
            return this.categories.find(cat => cat.id === this.selectedCategoryId)
        }
    },
    mounted() {
        categoryOrds.add(this.afaqCategoriesIn);
        categoryOrds
            .orderBy('order')
            .with('afaq_question_answers', (callback) => {
                callback
                    .with('afaq_tags')
                    .orderBy('order')
            })
            .get().subscribe((categories) => {
            this.categories = categories
        })
    },
    beforeDestroy() {
        this.subscription.unsubscribe();
    }
}
</script>

<style scoped lang="scss">
.sub-assignment-drag-handle {
    color: lightgray;
    margin-right: 15px;
}

.sub-assignment-drag-handle:hover {
    color: black;
}

.list-group-item {
    border: none;
    font-size: 0.875rem;
}

.list-group-item:hover,
.list-group-item.active {
    background-color: #e8eff4bf;
    color: #212529;
}

.edit-assignments .header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 21px;
    flex-direction: column;
}

.edit-assignments .header > > > .actions {
    align-self: flex-end;
}

.sub-assignments-edit-nav {
    margin-bottom: 60px;
}


@media (min-width: 768px) {

    .sub-assignments-edit-nav {
        margin-bottom: 0px;
    }

    .edit-assignments .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 21px;
        flex-direction: row;
    }

    .edit-assignments .header > > > .actions {
        align-self: baseline;
    }
}
</style>
